import * as React from 'react';

const CheckoutBillingAddressPlaceholder: React.StatelessComponent<{}> = () => {
  return (
    <div className="module" data-placeholder-rows>
      <ul className="actionable-rows">
        <li className="actionable-row actionable-row--placeholder">
          <div className="actionable-row__content"></div>
        </li>
        <li className="actionable-row actionable-row--placeholder">
          <div className="actionable-row__content"></div>
        </li>
      </ul>
    </div>
  );
};

export default CheckoutBillingAddressPlaceholder;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_billing_address_placeholder.tsx